<template>
  <div id="app" class="min-h-screen bg-appbg overflow-x-hidden">
    <div class="mx-auto max-w-screen-sm pt-4">
      <div v-if="me" class="px-4 flex items-center justify-between mb-2 text-xs text-primary">
        <span class="opacity-70">Здравствуйте, {{ me.first_name }}</span>
        <span class="font-bold">Баллы: {{ me.balance }}</span>
      </div>
      <router-view
        v-slot="routeProps"
        :cart-items="cartItems"
        :cartCount="cartItems.length"
      >
        <component
          :is="routeProps.Component || routeProps"
          v-bind="routeProps"
          :cart-items="cartItems"
          :cartCount="cartItems.length"
          :products="allProducts"
          :start-index="previewIndex"
          @add-to-cart="addToCartFromPreview"
          @open-preview="openPreviewViaRoute"
          @open-cart="goCart"
          @back="goCatalog"
          @remove-item="removeFromCart"
          @clear-cart="clearCart"
          @order-created="onOrderCreated"
        />
      </router-view>
    </div>
  </div>
</template>

<script>
import ProductCatalog from './components/Catalog.vue'
import CartPage from './components/CartPage.vue'
import ProductPreviewPage from './components/ProductPreviewPage.vue'
import api, { isInsideTelegram } from '@/services/api'

export default {
  name: 'App',
  components: { ProductCatalog, CartPage, ProductPreviewPage },
  data() {
    return {
      cartItems: [],
      allProducts: [],
      previewIndex: 0,
      me: null,
    }
  },
  methods: {
    async fetchMe() {
      try {
        const resp = await api.get('me')
        this.me = resp.data
      } catch (e) {
        // 401 в браузере — просто не показываем баланс
      }
    },
    onOrderCreated() {
      this.fetchMe()
      try { window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred?.('success') } catch (e) { /* noop */ }
    },
    clearCart() {
      this.cartItems = []
    },
    addToCart(product) {
      if (!product) return
      const normalized = this.normalizeCartProduct(product)
      const existingItem = this.cartItems.find(item => item._key === normalized._key)
      if (existingItem) {
        existingItem.quantity += 1
      } else {
        this.cartItems.push({ ...normalized, quantity: 1 })
      }
    },
    removeFromCart(item) {
      if (!item) return
      this.cartItems = this.cartItems.filter(ci => ci._key !== item._key)
    },
    goCart(){ this.$router.push({ name: 'cart' }) },
    goCatalog(){ this.$router.push({ name: 'catalog' }) },
    openPreviewViaRoute({ products, index }) {
      if (Array.isArray(products)) {
        this.allProducts = products
        this.previewIndex = index || 0
        const product = products[index]
        if (product && product.id) {
          this.$router.push({ name: 'product', params: { id: product.id } })
        }
      }
    },
    addToCartFromPreview(product) {
      if (!product) return
      const normalized = this.normalizeCartProduct(product)
      const existing = this.cartItems.find(i => i._key === normalized._key)
      if (existing) {
        existing.quantity = (existing.quantity || 1) + 1
      } else {
        this.cartItems.push({ ...normalized, quantity: 1 })
      }
    },
    normalizeCartProduct(p){
      const variantId = p.variantId || p.variant_id || p.selectedVariantId || ''
      const variantCode = p.variantCode || p.code || ''
      const selectedOptions = p.selectedOptions || {}
      if (p.selectedColor && !selectedOptions['Цвет']) selectedOptions['Цвет'] = p.selectedColor
      if (p.selectedSize && !selectedOptions['Размер']) selectedOptions['Размер'] = p.selectedSize

      const image = p.image || p.image_url || p.img || ''
      const price_preview = p.price_preview || p.price || 0
      const name = p.name || p.title || p.product_name || p.productName || 'Товар'

      const optionsKey = Object.entries(selectedOptions).sort().map(([k,v]) => `${k}:${v}`).join('|')

      return {
        id: p.id,
        name,
        price_preview,
        image,
        selectedOptions,
        selectedColor: selectedOptions['Цвет'] || selectedOptions['Color'] || null,
        selectedSize: selectedOptions['Размер'] || selectedOptions['Size'] || null,
        variantId: variantId || null,
        variantCode: variantCode || null,
        _key: [p.id, variantId || variantCode, optionsKey].filter(Boolean).join('_')
      }
    }
  },
  mounted() {
    if (isInsideTelegram) {
      this.fetchMe()
    }
  }
}
</script>

<style>
body { background: #F8F8F8; }
html, body, #app { overflow-x: hidden; }
</style>
